export const bucketEnumMapping = {
    assigned: "ASND",
    open: "OPEN",
    submitted: "SBMT",
    qcAllocated : "QCAL",
    rework : "REWK",
    qcDone : "QCD",
    qcRejected : "QCREJ",
    completed : "QCAP"
}